import React from 'react';
import ShowArticleDamagedStockProperties from "./ShowArticleDamagedStockProperties";
import { Box, Typography } from '@material-ui/core';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import useStyles from './ShowArticleDamagedStock.style';
import MarkDamagedArticleStockButton from '../../Buttons/MarkDamagedArticleStockButton/MarkDamagedArticleStockButton';
import CollectDamagedArticleStockButton from '../../Buttons/CollectDamagedArticleStockButton/CollectDamagedArticleStockButton';

const ShowArticleDamagedStock: React.FC<ShowArticleDamagedStockProperties> = ({
                                                    damagedAmount,
                                                    entityId,
                                                    articleId,
                                                    onSave = () => {
                                                    },
                                                    className = '',
                                                }) => {
    const classes = useStyles()

    return (
        <div className={`${classes.card} ${className}`}>
            <Box className={classes.container}>
                <Box className={classes.header}>
                    <BrokenImageIcon className={classes.small_damaged_icon} />
                    <Typography className={classes.label}>Dañados</Typography>
                    <Typography className={classes.value}>{damagedAmount}</Typography>
                </Box>
                <Box className={classes.actions}>
                    <MarkDamagedArticleStockButton
                        className={classes.action_link}
                        entityId={entityId}
                        articleId={articleId}
                        onSave={onSave}
                    />
                    <CollectDamagedArticleStockButton
                        className={classes.action_link}
                        entityId={entityId}
                        articleId={articleId}
                        damagedAmount={damagedAmount}
                        disabled={!damagedAmount}
                        onSave={onSave}
                    />
                </Box>
            </Box>
        </div>
    )
}
export default ShowArticleDamagedStock;
